// Copyright (c) Docugami, Inc. All rights reserved.

import React, { ReactNode } from "react";
import { useDrag } from "react-dnd";
import styled from "styled-components";
import { GroupCardContainer } from "./CardStyles";
import { DndReportItemGroup, DndType } from "./DndTypes";
import { CardletHeader } from "./ItemCardlet";
import { IReportEntryItemGroup } from "./ReportItemCardlet";
import { ReportGroupItemTitleInputField } from "./ReportItemTitleInputField";

const GroupHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 5px 5px 0px;
    box-sizing: border-box;
`;

const GroupContent = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
`;

interface ReportEntryItemGroupProps {
    group: IReportEntryItemGroup;
    dragDisabled?: boolean;
    readonly?: boolean;
    children: ReactNode;
}

export const ReportEntryItemGroup = (props: ReportEntryItemGroupProps): JSX.Element => {
    const [, dragRef, dragVisualRef] = useDrag<DndReportItemGroup, any, void>({
        type: DndType.ReportItemGroup,
        item: {
            type: DndType.ReportItemGroup,
            groupId: props.group.id
        },
        canDrag: !props.dragDisabled
    }, [props.group]);

    return (
        <GroupCardContainer id={props.group.id} ref={dragVisualRef}>
            <GroupHeader>
                <CardletHeader
                    label={<ReportGroupItemTitleInputField groupId={props.group.id} groupLabel={props.group.name} reportId={props.group.reportId} readonly={props.readonly} />}
                    dragHandleRef={!props.dragDisabled ? dragRef : undefined} />
            </GroupHeader>
            <GroupContent>
                {props.children}
            </GroupContent>
        </GroupCardContainer>
    )
}